import { z } from 'zod'

export const cashAccountSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(100),
  type: z.enum(['CASH', 'BANK'], { error: 'Tipo de conta obrigatório' }),
  openingBalance: z.coerce
    .number({ error: 'Saldo inicial inválido' })
    .nonnegative('Saldo inicial não pode ser negativo'),
  isDefault: z.boolean().optional().default(false),
})

export type CashAccountFormData = z.infer<typeof cashAccountSchema>

export const cashCategorySchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(60),
  kind: z.enum(['INFLOW', 'OUTFLOW'], { error: 'Tipo de categoria obrigatório' }),
})

export type CashCategoryFormData = z.infer<typeof cashCategorySchema>

export const cashTransactionSchema = z.object({
  accountId: z.string().min(1, 'Conta obrigatória'),
  categoryId: z.string().min(1, 'Categoria obrigatória'),
  type: z.enum(['INFLOW', 'OUTFLOW']),
  amount: z.coerce.number({ error: 'Valor inválido' }).positive('Valor deve ser positivo'),
  date: z.string().min(1, 'Data obrigatória'),
  description: z.string().min(1, 'Descrição obrigatória').max(200),
})

export type CashTransactionFormData = z.infer<typeof cashTransactionSchema>

export const cashTransferSchema = z
  .object({
    fromAccountId: z.string().min(1, 'Conta de origem obrigatória'),
    toAccountId: z.string().min(1, 'Conta de destino obrigatória'),
    amount: z.coerce.number({ error: 'Valor inválido' }).positive('Valor deve ser positivo'),
    date: z.string().min(1, 'Data obrigatória'),
    description: z.string().min(1, 'Descrição obrigatória').max(200),
  })
  .refine((d) => d.fromAccountId !== d.toAccountId, {
    message: 'A conta de destino deve ser diferente da origem',
    path: ['toAccountId'],
  })

export type CashTransferFormData = z.infer<typeof cashTransferSchema>
